import Vue from 'vue'
import VueRouter from 'vue-router'
// const Home = () => import('@/pages/home/home')
// const AboutUs = () => import('@/pages/about-us/about-us')
// const NewPatients = () => import('@/pages/new-patients/new-patients')
// const Treatment = () => import('@/pages/treatment/treatment')
// const Contact = () => import('@/pages/contact-us/contact-us')
// const PageNotFound = () => import('@/pages/404/404')

import Home from '@/pages/home/home'
import AboutUs from '@/pages/about-us/about-us'
import NewPatients from '@/pages/new-patients/new-patients'
import Treatment from '@/pages/treatment/treatment'
import Contact from '@/pages/contact-us/contact-us'
import Reviews from '@/pages/reviews/reviews'
import Accessibility from '@/pages/accessibility/accessibility'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: false,
      component: Home
    },
    {
      path: '/our-doctors',
      name: 'Our Doctors',
      navigation: true,
      component: AboutUs
    },
    {
      path: '/new-patients',
      name: 'New Patients',
      navigation: true,
      component: NewPatients
    },
    {
      path: '/treatment',
      name: 'Treatment',
      navigation: true,
      component: Treatment
    },
    {
      path: '/contact',
      name: 'Contact',
      navigation: true,
      component: Contact
    },
    {
      path: '/reviews',
      name: 'Reviews',
      navigation: false,
      component: Reviews
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/*',
      name: 'Redirect',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 150 }
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js